import FloatLabelInput from '@src/main/shared/ui/components/input/FloatLabelInput';
import { InputSwitch } from 'primereact/inputswitch';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface TypeFormProps {
  values: { title?: string; visibleOnApp?: boolean };
  handleChange: <K extends keyof TypeFormProps['values']>(
    field: K,
    value: TypeFormProps['values'][K],
  ) => void;
  errors?: Record<string, string>;
}

const TypeForm: FC<TypeFormProps> = ({ values, handleChange, errors }) => {
  const { t } = useTranslation();

  return (
    <form>
      <FloatLabelInput
        label={t('parameters.issues.titleField')}
        value={values.title ?? ''}
        onChange={(val) => handleChange('title', val)}
        error={errors?.title}
      />

      <label>{t('parameters.issues.visibleOnApp')}</label>
      <InputSwitch
        checked={values.visibleOnApp ?? false}
        onChange={(e) => handleChange('visibleOnApp', e.value)}
      />
    </form>
  );
};
export default TypeForm;
